import React, { useEffect, useState } from "react";

export default (props) => {
  const { adminActions, adminState } = props;

  const { settings } = adminState;

  useEffect(() => {
    adminActions.fetchSettings();
  }, []);

  if (!settings || adminState.loading) {
    return <div>Loading...</div>;
  }

  var items = [];

  for (var key in settings) {
    items.push({
      key,
      value: settings[key],
    });
  }

  return (
    <div>
      {items.map((e) => (
        <div key={e.key} style={{ marginBottom: 10 }}>
          <div style={{ fontWeight: "bold", marginBottom: 5 }}>{e.key}</div>
          <div style={{ fontSize: 14 }}>{e.value}</div>
        </div>
      ))}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/admin/components/SiteSettings.js